import {MailgunLogTypeEnum} from '@/services/api-clients';

export function mailgunLogTypeColorFilter(type: MailgunLogTypeEnum): string{
  switch (type) {
    case MailgunLogTypeEnum.Accepted: return 'success';
    case MailgunLogTypeEnum.Delivered: return 'primary';
    case MailgunLogTypeEnum.Failed: return 'error';
    case MailgunLogTypeEnum.Rejected: return 'warning';
    case MailgunLogTypeEnum.Clicked: return 'blue-grey lighten-2';
    case MailgunLogTypeEnum.Opened: return 'blue-grey lighten-2';
    case MailgunLogTypeEnum.Stored: return 'blue-grey lighten-2';
    case MailgunLogTypeEnum.Complained: return 'warning';
  }
}
